import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, isConfigured } from '../firebaseConfig';
import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  createUserWithEmailAndPassword
} from 'firebase/auth';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sign up new user
  function signup(email, password) {
    if (!isConfigured) {
      return Promise.reject(new Error('Firebase not configured'));
    }
    return createUserWithEmailAndPassword(auth, email, password);
  }

  // Login user
  function login(email, password) {
    if (!isConfigured) {
      return Promise.reject(new Error('Firebase not configured'));
    }
    return signInWithEmailAndPassword(auth, email, password);
  }

  // Logout user
  function logout() {
    if (!isConfigured) {
      return Promise.reject(new Error('Firebase not configured'));
    }
    return signOut(auth);
  }

  useEffect(() => {
    if (!isConfigured) {
      setLoading(false);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    signup,
    logout,
    isConfigured
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}